import { combineReducers } from 'redux';

import { alert } from './alert.reducer';
import { activity } from './activity.reducer';
import { modal } from './modal.reducer';
import { api } from './api.reducer';
import { airlines } from './airline.reducer';
import { requesting } from './requesting.reducer';
import { user } from './user.reducer';
import { users } from './users.reducer';
import {airlinesPayments} from "./airlinePayments.reducer";
import {azmanPayment} from "./azman.reducer";
import { dashboard } from './dashboard.reducer';
import { airports } from './airport.reducer';
import {alertConstants} from "../_constants"
import {entityTypes} from "./entityTypes.reducer"

const appReducers = combineReducers({
    user,
    users,
    alert,
    modal,
    activity,
    api,
    airlines,
    requesting,
    airlinesPayments,
    azmanPayment,
    dashboard,
    airports,
    entityTypes
});

const rootReducer = (state, action) => {
    if (action.type === alertConstants.RESET_APP) {
        state = undefined;
    }
    return appReducers(state, action);
};
export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js